import React from 'react';
import { Users } from 'lucide-react';

export default function DepartmentNode({ company, location, department, children, compact = false }) {
  if (compact) {
    return (
      <div data-testid={`settings-department-${department.id}`}>
        {children}
      </div>
    );
  }

  return (
    <div
      className={`flex min-w-0 items-center justify-between gap-3 border-b border-stone-100 last:border-b-0 ${compact ? 'px-3 py-0.5' : 'px-4 py-3 sm:px-5'}`}
      data-testid={`settings-department-${department.id}`}
    >
      <div className="min-w-0">
        <div className={`break-words font-semibold text-stone-800 ${compact ? 'text-sm' : ''}`}>{department.name}</div>
        <div className={`${compact ? 'flex-wrap' : ''} mt-0.5 flex items-center gap-1 text-xs text-stone-500`}>
          <Users className="h-3 w-3" aria-hidden="true" />
          {department.activeAssignments} attive
          {department.totalAssignments !== department.activeAssignments && (
            <span className="text-stone-400"> · {department.totalAssignments} totali</span>
          )}
        </div>
      </div>
      {children}
    </div>
  );
}